import { useEffect } from "react";
import { useQuery } from "@apollo/client";
import { clientCentralApiStrawberry } from "@neonumy/api-clients";
import { onErrorGraphql } from "utils/onErrorGraphql";
import { LIST_BUSSINESS_ACTIVITIES } from "queries/centralApi/companies";

interface BusinessActivity {
  code: string;
  name: string;
}

interface ListBusinessActivitiesOutput {
  listBusinessActivities: {
    results: BusinessActivity[];
  };
}

export default function useBusinessActivities() {
  const { data, loading, error } = useQuery<ListBusinessActivitiesOutput>(
    LIST_BUSSINESS_ACTIVITIES,
    {
      client: clientCentralApiStrawberry,
      variables: { filter: { search: "" } },
      fetchPolicy: "cache-first",
    },
  );

  useEffect(() => {
    if (error) onErrorGraphql(error);
  }, [error]);

  const options =
    data?.listBusinessActivities?.results?.map(item => ({
      label: `${item.code} - ${item.name}`,
      value: item.code,
    })) || [];

  return { options, loading };
}
